import React from 'react';

type SoccerProps = {};

const Soccer = (props: SoccerProps) => <div>Test</div>;

export default Soccer;
